import { NavBarPricing, ReferralIcon } from '@ankr.com/ui';
import { t } from '@ankr.com/common';

import { AccountPermission } from 'modules/permissions/constants';
import { NavigationItem } from 'modules/common/components/Navigation/components/BaseNavButton';
import { pricingRoutesConfig } from 'domains/pricing/routes';
import { referralsRoutesConfig } from 'domains/referrals/routes';

import { ISecondMenuItemsParams } from '../types';

export const getSecondMenuItems = ({
  isLoggedIn,
  isPartnerClient,
}: ISecondMenuItemsParams): NavigationItem[] => {
  const items: NavigationItem[] = [
    {
      StartIcon: NavBarPricing,
      href: pricingRoutesConfig.pricing.generatePath(),
      isHidden: isLoggedIn,
      label: t('main-navigation.pricing'),
      requiresPermission: AccountPermission.CommonMenuItem,
    },
    {
      StartIcon: ReferralIcon,
      href: referralsRoutesConfig.referrals.generatePath(),
      isDisabled: isPartnerClient,
      isHidden: !isLoggedIn,
      label: t('main-navigation.referrals'),
      requiresPermission: AccountPermission.CommonMenuItem,
    },
  ];

  return items.filter(item => !item.isHidden);
};
